class PandaError extends Error {
    constructor(message: string, code:number = 0, skipstack:boolean = false) {
        super(message);
        (this as any).__proto__ = new.target.prototype;
        this.message = message;
        this.code = code;
        this.name = Introspection.getClassName(this);
        if (!skipstack) {
            let error = new Error(this.message);
            if (!BrowserSpecific.hasStackOnUnthrowedError()) {
                try {
                    throw error;
                } catch (e) {}
            } 
        
            this.stack = this.getStack(error);
        }
    }

    public stack:string = null;
    public name:string = null;
    public message:string;
    public code:number;

    private _toString:string = null;
    public toString() {
        if (!this._toString) {
            this._toString = this.name + ': ' + this.message;
        }
        return this._toString;
    }

    private getStack(e:Error):string {
        let stack:string
        stack = PandaError.getStacktrace(e);
        if (!stack || stack === '') {
            return this.toString() + '\nstack unavailable';
        }
        let lines:Array<String> = stack.split('\n');
        if (lines[0] === ('Error: ' + this.message)) {
            lines.shift();
        }
        let obj = this;
        if (BrowserSpecific.errorHasExtenderConstructorLine()) {
            while (obj instanceof PandaError) {
                obj = Introspection.getObjectProto(obj);
                lines.shift();
            }
        }
        lines.unshift(this.toString());
        return lines.join('\n');
    }

    public static getStacktrace(error:Error):string {
        let stack:string;
        if (error) {
            try {
                stack = (<any>error)['stack'];
            } catch (e) {}
        }
        if (!stack) {
            try {
                stack = '';
                let f = arguments.callee.caller.caller;
                while (f) {
                    stack += (Introspection.getFunctionName(f) + '\n');
                    f = f.caller;
                }
            } catch(e){};
        }
        return stack;
    }
}

class NotImplementedError extends PandaError {
}